import { IUL30_EDITION, ROUTES } from "const";
import { courseService, examService, lessonLiveService } from "libs";

export class IUL30 {

  static async getDashboardCards(registrationCode, idExamSession) {
    let cards = this.getFixedCards(idExamSession);

    try {

      examService
        .getExamByRCode(registrationCode)
        .then((data) => {
          const { exam } = data.data.payload;
          if (exam) {
            if (exam.status !== 'revisioned') {
              if (idExamSession !== IUL30_EDITION.third_2024) {
                cards.push({
                  title: "Lezioni",
                  link: ROUTES.COURSE_LESSONLIVE_SCHEDULE_ONLINE,
                  img: "/img/icon/presentation.png",
                  className: "image-box",
                });
              }
            }
          }
        })
        .catch((errors) => {
          if (idExamSession !== IUL30_EDITION.third_2024) {
            cards.push({
              title: "Lezioni",
              link: ROUTES.COURSE_LESSONLIVE_SCHEDULE_ONLINE,
              img: "/img/icon/presentation.png",
              className: "image-box",
            });
          }
        });

      // verify dynamic links
      const result = await courseService.perfezionamentoActiveLink(
        registrationCode
      );
      if (result.data.payload) {

        const { payload } = result.data;

        if (payload.lessonLiveClassEnabled === "1") {

          const remoteResult = await lessonLiveService.isOpenClassBooking(
            registrationCode
          );

          const isBookingOpen =
            remoteResult &&
            remoteResult.data &&
            remoteResult.data.payload &&
            remoteResult.data.payload.length > 0;

          if (isBookingOpen) {
            cards.push({
              title: "Assegnazione Aula",
              link: ROUTES.COURSE_BOOKING_CLASS,
              img: "/img/icon/student.png",
              className: "image-box",
            });
          }
        }

        if (payload.SelfDeclarationEnabled === "1") {
          cards.push({
            title: "Autocertificazione d'iscrizione",
            link: ROUTES.USER_SELF_DECLARATION,
            img: "/img/icon/badge.png",
            className: "image-box",
          });
        }

        if (payload.examReservationEnabled === "1") {
          cards.push({
            title: "Prenotazione prova finale",
            link: ROUTES.COURSE_RC30_EXAM_RESERVATION,
            img: "/img/icon/badge.png",
            className: "image-box",
          });
        }

        if (payload.enableUDA === "1") {
          cards.push({
            title: "Prova scritta",
            link: ROUTES.COURSE_RC30_UDA_EXAMWRITTEN,
            img: "/img/icon/examdone.png",
            className: "image-box",
          });
        }

        if (payload.enableExamSubject === "1") {
          cards.push({
            title: "Argomento Lezione Simulata",
            link: ROUTES.COURSE_RC30_EXAM_SUBJECT,
            img: "/img/icon/7.png",
            className: "image-box",
          });
        }

        if (payload.certRequestEnabled === "1") {
          cards.push({
            title: "Consultazione Esito Finale",
            link: ROUTES.COURSE_RC30_CERT_REQUEST,
            img: "/img/icon/1.png",
            className: "image-box",
          });
        }

        if (payload.titleRequestEnabled === "1") {
          cards.push({
            title: 'Certificato Finale',
            link: ROUTES.MU_COURSE_TITLE_REQUEST,
            img: '/img/icon/graduate.png',
            className: 'image-box'
          });
        }

      }
    } catch (error) { }

    return cards;
  }

  static getFixedCards(idExamSession) {
    let cards = [
      {
        title: "Messaggi",
        link: ROUTES.COURSE_TICKETS,
        img: "/img/icon/message.png",
        className: "image-box",
      },
      {
        title: "Situazione pagamenti",
        link: ROUTES.MU_COURSE_PAYMENTS,
        img: "/img/icon/payment.png",
        className: "image-box",
      },
    ];

    return cards;
  }

  static getDashboardNotices(idExamSession, aa) {
    if (aa === 2024) {
      if (idExamSession === IUL30_EDITION.second_2024) {
        return [
          {
            title: `Linee guida svolgimento prova finale`,
            content: `<ul>
            <li>Sintesi svolgimento prova finale: <a href="https://www.formazionedocenti.it/files/corsi/IUL30/sintesi_svolgimento_prova_finale.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></li>
            <li>Modalità di svolgimento prova finale: <a href="https://www.formazionedocenti.it/files/corsi/IUL30/modalita_svolgimento_prova_finale.pdf" target="_blank">Clicca qui per scaricare l'informativa</a></li>
            <li>Modello lezione simulata: <a href="https://www.formazionedocenti.it/files/corsi/IUL30/modello_lezione_simulata_iul30.docx">Clicca qui per scaricare l'informativa</a></li>
            </ul>`,
          },
          {
            title: `9 Giugno 2025: lezioni propedeutiche allo svolgimento delle prove finali.`,
            content: `La partecipazione è strettamente consigliata.`,
          },
          {
            title: `Calendario Corsi Abilitanti 30 CFU (ex art.13 DPCM 4 agosto 2023)`,
            content: `Seconda fase del percorso - <a href="https://www.formazionedocenti.it/files/corsi/IUL30/calendario-lezioni-iul30-2024-II.pdf" target="_blank">Clicca qui per scaricare il calendario</a>`,
          },
          {
            title: `Calendario Corsi Abilitanti 30 CFU (ex art.13 DPCM 4 agosto 2023)`,
            content: `Prima fase del percorso - <a href="https://www.formazionedocenti.it/files/corsi/IUL30/calendario-lezioni-iul30-2024-I.pdf" target="_blank">Clicca qui per scaricare il calendario</a>`,
          },
          {
            title: `Linee guida svolgimento delle lezioni`,
            content: `<p><a href="https://www.formazionedocenti.it/files/corsi/RC30/linee-guida-lezioni-30cfu-generic.pdf" target="_blank">Clicca qui per scaricare le linee guida</a></p>`,
          }
        ];
      } else {

      }
    } else {

    }
  }
}
